import { IApiSkinTrack } from './IApiSkinTrack'
import { IMark, ISkinTrack } from '../ISkinTrack'

export const transform = (apiSkinTrack: IApiSkinTrack): ISkinTrack => {
    return  {
        customerUuid: apiSkinTrack.customer_uuid,
        id: apiSkinTrack.uuid,
        limb: apiSkinTrack.limb,
        revisions: apiSkinTrack.revisions.map(
            (apiRevision, index) => ({
                revision: apiRevision.revision,
                note: apiRevision.note,
                marks: apiRevision.marks.map((apiMark): IMark => ({
                    id: apiMark.id,
                    color: apiMark.color,
                    fromLeft: apiMark.from_left,
                    fromTop: apiMark.from_top
                })),
                isLocked: index > 0
            })
        )
    }
}
